import { Box, Divider } from '@mui/material';
import PageHeader from '../../organisms/PageHeader/PageHeader';
import VideoHeader from '../../organisms/PageHeader/PageHeaders/VIdeoHeader/VideoHeader';

function VideoDashboard() {
  return (
    <Box
      sx={{
        height: '64px',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#fff',
      }}
    >
      <PageHeader
        showBackArrowButton={false}
        headerContent={(
          <VideoHeader variant="page" />
        )}
      />
      <Divider />
    </Box>
  );
}

export default VideoDashboard;
